import { render, staticRenderFns } from "./sms.vue?vue&type=template&id=3fa13432&"
import script from "./sms.vue?vue&type=script&lang=ts&"
export * from "./sms.vue?vue&type=script&lang=ts&"
import style0 from "./sms.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports